import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import CONSTANTS from 'src/@utility/constants';
import { StorageService } from './storage.service';
import { RequestService } from './request.service';

@Injectable({
  providedIn: 'root',
})
export class LocaleService {
  locale: any;
  private localeUpdate = new ReplaySubject<any>(1);
  private localeUpdate$ = this.localeUpdate.asObservable();

  constructor(
    private restApi: RequestService,
    private storageService: StorageService
  ) {
    this.locale = this.storageService.getItem(CONSTANTS.appLocaleKey);
  }

  load() {
    if (this.locale) {
      this.localeUpdate.next(this.locale);
      return this.localeUpdate$;
    }

    this.restApi
      .get('/api/sa-locales')
      .pipe(
        switchMap((localesResponse) =>
          this.restApi.get('/api/sa-labels', { size: 2147483647 }).pipe(
            map((labelsResponse) => {
              const localesObject = localesResponse.body.reduce((acc, obj) => {
                acc[obj.id] = { ...obj, data: {} };
                return acc;
              }, {});
              labelsResponse.body.forEach((label) => {
                const locale = localesObject[label.locale.id];
                if (locale) {
                  localesObject[locale.id].data[label.uiId] = {
                    value: label.value,
                  };
                }
              });
              return localesObject;
            })
          )
        )
      )
      .subscribe((response) => {
        this.storageService.setItem(CONSTANTS.appLocaleKey, response);
        this.localeUpdate.next(response);
      });

    return this.localeUpdate$;
  }
}
